<template>
	<bee-label :empty-state="emptyState" :bold="bold" 
	:color="color" 
	:content="content"></bee-label>  
</template>
<script>
export default {
props:["account", "emptyState", "color", "bold"],
name: "BeeAccountLabel",
computed:{
	content(){
		if(this.account?.name && this.account?.accounting_no) return this.account.accounting_no + "-" + this.account.name
		if(this.account?.name) return this.account.name 
		return this.account
	}
}
}
</script>
<style scoped>
</style>